import { useEffect } from "react";
import { setTheme } from "../utils/utils";

import ProductDetailPage from "./ProductDetailPage";
import ProductMaxCapitalDetailPage from "./ProductMaxCapitalDetailPage";

setTheme("light");

export default function BaseProductDetailPage() {
    const isFondo = window.location.pathname.split("/").includes("fondos");

    useEffect(() => {
        const headerMob = document.querySelector(".header.--below-895");
        const headerDesk = document.querySelector(".header.--above-895");

        headerMob.classList.add("--theme-light");
        headerMob.classList.remove("--theme-dark");
        headerDesk.classList.add("--theme-light");
        headerDesk.classList.remove("--theme-dark");
    }, []);

    return isFondo ? (
        // Fondos o max capital
        <ProductMaxCapitalDetailPage />
    ) : (
        // Resto de los productos
        <ProductDetailPage />
    );
}
